// extracted by mini-css-extract-plugin
export var actionButton = "_il-0";
export var fileInput = "_il-2";
export var paperclip = "_il-1";